import React, { useEffect } from 'react'
import { LocaleProvider } from '@vp/digital-locale-lib-ubik'
import { getClientEnvironment, RuntimeContextProvider } from '@vp/digital-environment-lib-ubik'
import { IdentityProvider, useSwanStyleKeys, VPAuthConfig } from '@vp/ubik-context'
import WixDomainsPdp from './src/WixDomainsPdp'
import { trackDomainsPageViewed } from './src/WixDomainsPDPAnalytics'

export function ProductApp(props: any) {
  useSwanStyleKeys(['core', 'button', 'banner', 'progressiveImage', 'spinner', 'grid'])

  const createAuthConfig = (culture: string, isDevelopment: boolean): VPAuthConfig => ({
    culture,
    developmentMode: isDevelopment,
    options: {
      requireSession: true,
      customText: 'Sign in to see your account',
    },
  })

  // Analytics
  useEffect(() => {
    trackDomainsPageViewed()
  }, [])

  return (
    <LocaleProvider rawLocaleIdentifier={props.locale}>
      <RuntimeContextProvider getEnvironment={getClientEnvironment}>
        <IdentityProvider auth={createAuthConfig(props.locale, false)}>
          <WixDomainsPdp {...props} />
        </IdentityProvider>
      </RuntimeContextProvider>
    </LocaleProvider>
  )
}
